<nav class="branded-navbar">
  <div class="navbar-container">
    <div class="navbar-logo">
      <img [src]="logoMain" [alt]="brandName" class="logo-img" />
    </div>
  </div>
</nav>

<main class="HomePage">
  <div class="main-content-wrapper">

    <!-- Loading -->
    <section class="card center" *ngIf="state === 'loading'">
      <div class="waiting-spinner" aria-hidden="true"></div>
      <p>Cargando tu información…</p>
    </section>

    <!-- Error -->
    <section class="card center" *ngIf="state === 'error'">
      <h1 class="title">No se pudo abrir el enlace</h1>
      <p class="subtitle">{{ errorMessage }}</p>
    </section>

    <!-- Pending: review + sign -->
    <ng-container *ngIf="state === 'pending'">
      <h1 class="page-title">Verifica tu información</h1>
      <p class="subtitle">Revisa los datos y firma para completar tu asistencia.</p>

      <div class="reject-banner" *ngIf="rejectionReason">
        El asesor solicitó que vuelvas a firmar<span *ngIf="rejectionReason !== 'No validada'">: {{ rejectionReason }}</span>. Por favor, realiza tu firma nuevamente.
      </div>

      <div class="card">
        <div class="readonly-grid">
          <div class="readonly-field"><span class="ro-label">Tipo de identificación</span><span class="ro-value">{{ customer['identificationType'] || '—' }}</span></div>
          <div class="readonly-field"><span class="ro-label">Identificación</span><span class="ro-value">{{ customer['nationalId'] || '—' }}</span></div>
          <div class="readonly-field"><span class="ro-label">Fecha de nacimiento</span><span class="ro-value">{{ customer['birthDate'] || '—' }}</span></div>
          <div class="readonly-field"><span class="ro-label">Nombres</span><span class="ro-value">{{ customer['firstName'] || '—' }}</span></div>
          <div class="readonly-field"><span class="ro-label">Apellidos</span><span class="ro-value">{{ customer['lastName'] || '—' }}</span></div>
          <div class="readonly-field"><span class="ro-label">Género</span><span class="ro-value">{{ customer['gender'] || '—' }}</span></div>
          <div class="readonly-field"><span class="ro-label">Teléfono</span><span class="ro-value">{{ customer['phone'] || '—' }}</span></div>
          <div class="readonly-field"><span class="ro-label">Correo electrónico</span><span class="ro-value">{{ customer['email'] || '—' }}</span></div>
          <div class="readonly-field"><span class="ro-label">País de residencia</span><span class="ro-value">{{ customer['country'] || '—' }}</span></div>
        </div>
      </div>

      <div class="card" *ngIf="dependents.length">
        <h4 class="section-title-left"><b>Dependientes</b></h4>
        <div class="dependent-cards">
          <div class="dependent-card" *ngFor="let dep of dependents">
            <div><strong>{{ dep.name || '—' }}</strong></div>
            <div>{{ dep.identification || '—' }}</div>
            <div class="muted">{{ dep.birthday || '—' }}</div>
          </div>
        </div>
      </div>

      <h4 class="section-title-left"><b>Firma</b></h4>
      <div class="signature-card">
        <app-signature-canvas (saved)="onSignatureSaved($event)"></app-signature-canvas>
      </div>

      <p class="error-text" *ngIf="errorMessage">{{ errorMessage }}</p>

      <div class="pay-and-secure-row signature-submit-row">
        <button
          class="pay-button"
          type="button"
          [disabled]="!canSubmit"
          (click)="submitSignature()">
          {{ submitting ? 'Enviando…' : 'Firmar' }}
        </button>
      </div>
    </ng-container>

    <!-- Signed, waiting for seller -->
    <section class="card center" *ngIf="state === 'signedWaiting'">
      <div class="waiting-spinner" aria-hidden="true"></div>
      <h1 class="title">Firma registrada</h1>
      <p class="subtitle">
        Recibimos tu firma correctamente. Estamos esperando la validación del asesor para emitir tu asistencia.
      </p>
    </section>

    <!-- Emitted / already purchased: thank-you summary -->
    <ng-container *ngIf="state === 'emitted' || state === 'alreadyPurchased'">
      <div class="thank-you-column">
        <div class="thank-you-success-message">
          <div class="success-icon">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="var(--brand-secondary)" stroke-width="2" fill="var(--brand-secondary)" opacity="0.15" />
              <path d="M9 12l2 2 4-4" stroke="var(--brand-primary)" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <h1 class="success-title">
            {{ state === 'alreadyPurchased' ? 'Este enlace ya fue procesado' : '¡Compra realizada con éxito!' }}
          </h1>
          <p class="success-subtitle">Tu asistencia ha sido emitida correctamente</p>
        </div>

        <div class="policy-info-card">
          <div class="policy-header"><h3>Información de tu póliza</h3></div>
          <div class="policy-details">
            <div class="policy-number">
              <span class="ro-label">Número de póliza:</span>
              <span class="policy-value">{{ policyNumber || 'En proceso' }}</span>
            </div>
            <div class="purchase-date" *ngIf="purchaseDate">
              <span class="ro-label">Fecha de compra:</span>
              <span>{{ purchaseDate }}</span>
            </div>
          </div>
        </div>

        <div class="purchase-summary-card">
          <div class="summary-header"><h3>Resumen de tu compra</h3></div>
          <div class="summary-content">
            <div class="plan-info">
              <h4>Plan contratado</h4>
              <div class="plan-details">
                <div class="detail-row"><span class="label">Plan:</span><span class="value">{{ planSummary.name || 'Plan de asistencia' }}</span></div>
                <div class="detail-row" *ngIf="planSummary.description && planSummary.description !== planSummary.name"><span class="label">Descripción:</span><span class="value">{{ planSummary.description }}</span></div>
                <div class="detail-row"><span class="label">Precio:</span><span class="value price-highlight">{{ planSummary.formattedPrice }}</span></div>
                <div class="detail-row" *ngIf="planSummary.effectiveDate"><span class="label">Fecha efectiva:</span><span class="value">{{ planSummary.effectiveDate }}</span></div>
              </div>
            </div>

            <div class="customer-info" *ngIf="customerInfo['fullName']">
              <h4>Titular de la póliza</h4>
              <div class="customer-details">
                <div class="detail-row"><span class="label">Nombre:</span><span class="value">{{ customerInfo['fullName'] }}</span></div>
                <div class="detail-row"><span class="label">Identificación:</span><span class="value">{{ customerInfo['nationalId'] }}</span></div>
                <div class="detail-row" *ngIf="customerInfo['email']"><span class="label">Email:</span><span class="value">{{ customerInfo['email'] }}</span></div>
                <div class="detail-row" *ngIf="customerInfo['phone']"><span class="label">Teléfono:</span><span class="value">{{ customerInfo['phone'] }}</span></div>
                <div class="detail-row" *ngIf="customerInfo['gender']"><span class="label">Género:</span><span class="value">{{ customerInfo['gender'] }}</span></div>
                <div class="detail-row" *ngIf="customerInfo['address']"><span class="label">Dirección:</span><span class="value">{{ customerInfo['address'] }}</span></div>
              </div>
            </div>

            <div class="dependents-info" *ngIf="dependents.length">
              <h4>Dependientes incluidos ({{ dependents.length }})</h4>
              <div class="dependents-list">
                <div class="dependent-item" *ngFor="let dep of dependents">
                  <div class="dependent-name">{{ dep.name }}</div>
                  <div class="dependent-details">
                    <span class="dependent-id">{{ dep.identification }}</span>
                    <span class="dependent-relationship badge">{{ dep.birthday }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="document-actions-card" *ngIf="canDownloadDocument">
          <button type="button" class="document-print-button" (click)="printDocument()" [disabled]="isPrintingDocument">
            <span *ngIf="!isPrintingDocument">Imprimir Documento Legal</span>
            <span *ngIf="isPrintingDocument">Generando documento…</span>
          </button>
          <div class="document-status" *ngIf="documentStatusMessage" [ngClass]="documentStatusType">
            {{ documentStatusMessage }}
          </div>
        </div>
      </div>
    </ng-container>

  </div>
</main>

<footer class="branded-footer">
  <div class="footer-container">
    <div class="footer-content">
      <div class="footer-logo">
        <img [src]="logoFooter" [alt]="brandName" class="footer-logo-img" />
      </div>
      <div class="footer-info" *ngIf="poweredBy">
        <img [src]="poweredBy" alt="Powered by" class="powered-by-logo" />
      </div>
    </div>
  </div>
</footer>
